(function (root, factory) {
  var exports = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = exports;
  }

  root.GanShopifyFormsScope = exports;

  if (
    root &&
    root.document &&
    root.__ganShopifyFormsScopeInitialized !== true
  ) {
    root.__ganShopifyFormsScopeInitialized = true;
    exports.autoInit(root, root.document);
  }
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  var ALLOWED_PATHS = ['/collections/minions-collection', '/collections/best-sellers'];
  var TARGET_FORM_ID = '1063652';
  var INLINE_ROOT_ID = 'forms-root-' + TARGET_FORM_ID;
  var APP_EMBED_CONTAINER_ID = 'app-embed-container-' + TARGET_FORM_ID;
  var TARGET_SELECTOR =
    '#app-embed-container-' +
    TARGET_FORM_ID +
    ',[data-forms-id="forms-root-' +
    TARGET_FORM_ID +
    '"]';

  function normalizePath(path) {
    var normalized = String(path || '');
    var queryIndex = normalized.indexOf('?');
    var hashIndex = normalized.indexOf('#');
    var endIndex = normalized.length;

    if (queryIndex !== -1 && queryIndex < endIndex) {
      endIndex = queryIndex;
    }

    if (hashIndex !== -1 && hashIndex < endIndex) {
      endIndex = hashIndex;
    }

    normalized = normalized.slice(0, endIndex) || '/';

    if (normalized.length > 1 && normalized.charAt(normalized.length - 1) === '/') {
      normalized = normalized.slice(0, -1);
    }

    return normalized;
  }

  function isAllowedPage(path) {
    var normalized = normalizePath(path);
    for (var i = 0; i < ALLOWED_PATHS.length; i += 1) {
      if (ALLOWED_PATHS[i] === normalized) {
        return true;
      }
    }
    return false;
  }

  function getDataFormsId(target) {
    if (!target || typeof target.getAttribute !== 'function') {
      return '';
    }

    return target.getAttribute('data-forms-id') || '';
  }

  function matchesFormsTarget(target) {
    var dataFormsId;

    if (!target) {
      return false;
    }

    if (typeof target.id === 'string' && target.id === APP_EMBED_CONTAINER_ID) {
      return true;
    }

    dataFormsId = getDataFormsId(target);
    return dataFormsId === INLINE_ROOT_ID;
  }

  function hideTarget(target) {
    if (!matchesFormsTarget(target)) {
      return false;
    }

    if (typeof target.setAttribute === 'function') {
      target.setAttribute('aria-hidden', 'true');
    }

    target.hidden = true;

    if (target.style && typeof target.style.setProperty === 'function') {
      target.style.setProperty('display', 'none', 'important');
      target.style.setProperty('visibility', 'hidden', 'important');
      target.style.setProperty('opacity', '0', 'important');
      target.style.setProperty('pointer-events', 'none', 'important');
    }

    return true;
  }

  function suppressForms(doc) {
    var matches;
    var index;
    var hiddenCount;

    if (!doc || typeof doc.querySelectorAll !== 'function') {
      return 0;
    }

    matches = doc.querySelectorAll(TARGET_SELECTOR);
    hiddenCount = 0;

    for (index = 0; index < matches.length; index += 1) {
      if (hideTarget(matches[index])) {
        hiddenCount += 1;
      }
    }

    return hiddenCount;
  }

  function autoInit(win, doc) {
    var observer;
    var scheduled;
    var rootNode;
    var htmlDataset;

    if (!win || !doc) {
      return null;
    }

    htmlDataset = doc.documentElement && doc.documentElement.dataset;
    if (htmlDataset && htmlDataset.shopifyForm1063652Allowed === 'true') {
      return null;
    }

    suppressForms(doc);

    if (typeof win.MutationObserver !== 'function') {
      return null;
    }

    scheduled = false;
    rootNode = doc.documentElement || doc.body;
    if (!rootNode) {
      return null;
    }

    observer = new win.MutationObserver(function () {
      if (scheduled) {
        return;
      }

      scheduled = true;
      win.setTimeout(function () {
        scheduled = false;
        suppressForms(doc);
      }, 0);
    });

    observer.observe(rootNode, {
      childList: true,
      subtree: true,
    });

    return observer;
  }

  return {
    ALLOWED_PATHS: ALLOWED_PATHS,
    TARGET_FORM_ID: TARGET_FORM_ID,
    INLINE_ROOT_ID: INLINE_ROOT_ID,
    APP_EMBED_CONTAINER_ID: APP_EMBED_CONTAINER_ID,
    TARGET_SELECTOR: TARGET_SELECTOR,
    normalizePath: normalizePath,
    isAllowedPage: isAllowedPage,
    matchesFormsTarget: matchesFormsTarget,
    hideTarget: hideTarget,
    suppressForms: suppressForms,
    autoInit: autoInit,
  };
});
